<template>
  <BaseDialog centered contentClass="edit-normalized-name" ref="dialog" persistent show-actions>
    <template slot="title">{{ $t('page.admin-tenant.normalized-names.edit-dialog.title') }}</template>
    <template slot="content">
      <form @click.prevent>
        <FormInput
          ref="normalizedNameValue"
          :label="$t('page.admin-tenant.normalized-names.edit-dialog.name')"
          is-required
          has-gray-background
          name="name"
          type="name"
          v-model="normalizedName"
          v-validate="'required'"
        />
        <div class="edit-normalized-name__actions">
          <FormButton is-outlined class="edit-normalized-name__cancel" @click.native="cancelClick">{{
            $t('actions.cancel')
          }}</FormButton>
          <FormButton @click.native="onSubmit" type="submit" :disabled="isFormInvalid">
            <span>{{ $t('actions.save') }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormInput from '@/components/form/FormInput.vue';
import FormButton from '@/components/form/FormButton.vue';

import { mapActions } from 'vuex';

export default {
  name: 'EditCategoryDialog',
  components: {
    BaseDialog,
    FormInput,
    FormButton,
  },
  data() {
    return {
      id: '',
      normalizedName: '',
      initialNormalizedName: '',
    };
  },
  computed: {
    isFormInvalid() {
      return !!!this.normalizedName || !this.isDirty;
    },
    isDirty() {
      const nameChanged = this.normalizedName !== this.initialNormalizedName;
      return nameChanged;
    },
  },
  methods: {
    ...mapActions('biDashboard', ['editTenantNormalizedName']),
    open({ id, normalizedName }) {
      this.id = id;
      this.normalizedName = normalizedName;
      this.initialNormalizedName = normalizedName;

      this.$refs.dialog.openModal();

      this.$nextTick(() => {
        const refInput = this.$refs.normalizedNameValue.$el.querySelector('input');
        if (refInput) {
          this.$nextTick(() => {
            refInput.focus();
          });
        }
      });
    },
    close() {
      this.normalizedName = '';
      this.initialNormalizedName = '';
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      this.editTenantNormalizedName({ id: this.id, normalizedName: this.normalizedName })
        .then(() => {
          this.$toast.success(this.$t('page.admin-tenant.normalized-names.edit-dialog.edit-normalized-name-success'));
        })
        .catch((error) => this.$toast.error(error));
      this.close();
    },
    cancelClick() {
      this.close();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__edit-normalized-name {
  height: auto;
  width: 550px;
  position: relative;

  .base-dialog__content {
    padding: 8px 32px 32px 32px !important;
    font-size: 18px;
    background: $color-white !important;
  }
  .close-icon__container {
    display: none;
  }
}
.edit-normalized-name {
  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    margin-right: 12px;
  }

  &__action {
    text-transform: lowercase;
    font-weight: bold;
  }
}
</style>
